var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_vm._l((_vm.resources),function(resource){return _c('ShowScheduleTile',{key:`show-schedule-item-${resource.air_start + resource.id || resource.id}`,attrs:{"schedule-item":resource,"artwork":""}})}),(_vm.resources.length === 0 && _vm.error)?_c('BaseEmptyList',{attrs:{"error":_vm.error}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }